import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { ROUTE_PATHS } from "@/lib/index";
import Home from "@/pages/Home";

/**
 * React Query Client configuration
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
});

/**
 * Root App component managing the restaurant website routing and global providers.
 * 
 * NASI ARAB MERWIY (2026)
 * Based in Meru, Klang. Specializing in Mandy Ayam & Kambing.
 */
function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <BrowserRouter>
          <Routes>
            {/* Main Landing Page */}
            <Route path={ROUTE_PATHS.HOME} element={<Home />} />
            
            {/* 
              Note: No custom 404 page requested in Task List.
              Redirecting any unknown routes to Home to maintain simple user flow.
            */}
            <Route path="*" element={<Home />} />
          </Routes>
        </BrowserRouter>
        
        {/* Feedback Components */}
        <Toaster />
        <Sonner position="bottom-center" richColors />
      </TooltipProvider>
    </QueryClientProvider>
  );
}

export default App;
